import {
    IndexNowPingAllButton,
    SourceCheckTool,
} from "@/pages/AdminCreators";
import {
    AdminHandleLookupPanel,
    DemoBuildSection,
    RescoreAnswersTile,
} from "@/pages/Profile";

/**
 * Admin tools page. Mounts every admin utility that used to be scattered
 * across /profile and the old admin pages, so nothing is lost before the
 * dedicated redesign in slice 4.
 *
 * Tiles in slice 1:
 *   - Source check (TikTok oEmbed + URL fallback)
 *   - IndexNow ping-all
 *   - Handle lookup (claim or re-release a samoony handle)
 *   - Demo build + Recent demo builds + Rescore answers (all inside
 *     DemoBuildSection today; stays whole until slice 4 splits it)
 */
export default function AdminTools() {
    return (
        <section data-testid="admin-tools-wrapper">
            <header className="mb-5">
                <h1 className="font-display text-3xl font-bold tracking-tight">
                    Tools
                </h1>
                <p className="text-sm text-black/60 mt-1">
                    Diagnostic utilities. These never write to a creator record
                    unless explicitly saved.
                </p>
            </header>
            <div className="grid grid-cols-1 gap-4">
                <SourceCheckTool />
                <IndexNowPingAllButton />
                <div
                    data-testid="admin-tools-handle-lookup"
                    className="bg-white border border-black/10 rounded-2xl p-5"
                >
                    <div className="samoony-label mb-3">Handle lookup</div>
                    <AdminHandleLookupPanel />
                </div>
                <div
                    data-testid="admin-tools-demo-build"
                    className="bg-white border border-black/10 rounded-2xl p-5"
                >
                    <div className="samoony-label mb-3">
                        Demo build · Recent demo builds
                    </div>
                    <DemoBuildSection />
                </div>
                <RescoreAnswersTile />
            </div>
        </section>
    );
}
